import { render, staticRenderFns } from "./HospitalDetails.vue?vue&type=template&id=f501e354"
import script from "./HospitalDetails.vue?vue&type=script&lang=js"
export * from "./HospitalDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports